import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { NavItemRoot, NavItemSub } from './NavItem';
import { getActive } from '..';

/* ============================================================================
   Grupo do menu horizontal - visual novo.

   MUDANCA DE COMPORTAMENTO DELIBERADA: o submenu abre por CLIQUE, nao por
   passagem do mouse.

   A versao MUI usava `onMouseEnter`/`onMouseLeave` com Popover. Menu que abre ao
   passar o mouse dispara sozinho quando a pessoa esta so atravessando a barra para
   chegar em outro item, e no toque (tablet) o `mouseenter` acontece junto com o
   clique - o painel abria e fechava no mesmo gesto. Clique funciona igual nos dois.

   Submenus de terceiro nivel sao mostrados ACHATADOS, com o nome do pai como
   rotulo de secao: um painel com dois niveis de recuo dentro de uma barra
   horizontal fica mais difícil de ler que a lista completa.
   ============================================================================ */

export function NavListRoot({ list }) {
  const { pathname, asPath } = useRouter();
  const [open, setOpen] = useState(false);
  const raiz = useRef(null);

  const active = getActive(list.path, pathname, asPath);
  const filhos = list.children || [];
  const temFilhoAtivo = filhos.some(
    (f) => getActive(f.path, pathname, asPath) || (f.children || []).some((n) => getActive(n.path, pathname, asPath))
  );

  useEffect(() => {
    if (!open) return;
    const aoApontar = (e) => {
      if (raiz.current && !raiz.current.contains(e.target)) setOpen(false);
    };
    const aoTeclar = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', aoApontar);
    window.addEventListener('keydown', aoTeclar);
    return () => {
      document.removeEventListener('mousedown', aoApontar);
      window.removeEventListener('keydown', aoTeclar);
    };
  }, [open]);

  if (!filhos.length) {
    return <NavItemRoot item={list} active={active} />;
  }

  return (
    <div className="relative flex-none" ref={raiz}>
      <NavItemRoot item={list} active={active || temFilhoAtivo} open={open} onToggle={() => setOpen(!open)} />

      {open && (
        <div className="absolute left-0 top-[calc(100%+6px)] z-[1300] w-[240px] max-w-[92vw] rounded-lg border border-line bg-surface p-1.5 shadow-card">
          {filhos.map((filho) =>
            filho.children?.length ? (
              <div key={filho.title} className="mb-1">
                <div className="px-2.5 pb-0.5 pt-1.5 text-[10px] font-bold uppercase tracking-[0.08em] text-faint">
                  {filho.title}
                </div>
                {filho.children.map((neto) => (
                  <NavItemSub
                    key={neto.title}
                    item={neto}
                    active={getActive(neto.path, pathname, asPath)}
                    aoNavegar={() => setOpen(false)}
                  />
                ))}
              </div>
            ) : (
              <NavItemSub
                key={filho.title}
                item={filho}
                active={getActive(filho.path, pathname, asPath)}
                aoNavegar={() => setOpen(false)}
              />
            )
          )}
        </div>
      )}
    </div>
  );
}
